import { StatusBadge } from '@jurnee/common/src/components/StatusBadge';
import { PartnerDocumentJSON } from '@jurnee/common/src/entities/PartnerDocument';
import { RateJSON } from '@jurnee/common/src/entities/Rate';
import { PaymentStatus, getPaidPercentage, getPaymentStatus } from '@jurnee/common/src/utils/partnerDocuments';
import { Trans } from 'react-i18next';

interface Props {
  partnerDocuments: PartnerDocumentJSON[];
  rate: RateJSON;
}

function getColor(status: PaymentStatus) {
  if (status === 'PAID_FULLY') {
    return 'teal';
  }

  if (status === 'PAID_PARTIALLY') {
    return 'blue';
  }

  return 'gray';
}

export function PaymentStatus({ partnerDocuments, rate }: Props) {
  const status = getPaymentStatus(partnerDocuments, rate);

  const color = getColor(status);
  const percentage = getPaidPercentage(partnerDocuments, rate);
  const label = <Trans i18nKey={`invoice:status.${status}`} values={{ percentage }} />;

  return <StatusBadge label={label} color={color} />;
}